import {
  GET_ADMIN_BY_ID,
  GET_ADMIN_LIST,
  GET_ADMIN_ROLES_BY_ID,
} from "../constants";
import axiosInstance from "../api/index";
import swal from "sweetalert";

export const addAdmin = (data, setLoading, navigate) => async (dispatch) => {
  setLoading(true);

  try {
    const response = await axiosInstance.post(`admin/create`, data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/admin")
      return response;
    }
    else {
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

export const getAdminList = (data, setLoading) => async (dispatch) => {
  setLoading(true)
  try {
    const response = await axiosInstance.post(`admin/get_all`, data);
    if (response?.data?.status) {
      dispatch({ type: GET_ADMIN_LIST, adminList: response.data.response });
    } else {
      dispatch({ type: GET_ADMIN_LIST, adminList: [] });
    }
    setLoading(false)
  } catch (err) {
    console.error(err);
    setLoading(false)
    dispatch({ type: GET_ADMIN_LIST, adminList: [] });
  }
};

export const getAdminById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`admin/get_byid/${id}`);
    if (response?.data?.status) {
      dispatch({ type: GET_ADMIN_BY_ID, updateadmin: response.data.response });
      return response;
    }
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
    console.error(err);
  } finally {
  }
};

export const updateAdmin = (data, setLoading, navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post(`admin/update`, data);
    if (response?.data?.status) {
      dispatch(getAdminById(data.id));
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/admin")
      return response;
    }
    else {
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

export const getAdminRolesById = (id, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.get(`admin_role?type=${id}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_ADMIN_ROLES_BY_ID,
        getadminroles: response.data.response,
      });
      return response;
    }
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

export const deleteAdmin = (id, setLoading, params) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.delete(`admin/delete/${id}`);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      // dispatch(getAdminList(params));
      window.location.reload()

      return response;
    }
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};
